import React from 'react';

// Generic marquee — horizontal or vertical, optional reverse + pause-on-hover.
// Ported from a shadcn TSX snippet to plain JS, with no `cn` dependency.
// The animation classes (`animate-marquee`, `animate-marquee-vertical`) and
// their `--duration` / `--gap` CSS variables are defined in tailwind.config.js.

function cx(...parts) {
  return parts.filter(Boolean).join(' ');
}

export default function Marquee({
  className,
  reverse = false,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 4,
  ariaLabel,
  ariaLive = 'off',
  ariaRole = 'marquee',
  ...rest
}) {
  return (
    <div
      {...rest}
      className={cx(
        'group flex overflow-hidden p-2 [--duration:40s] [--gap:1rem] [gap:var(--gap)]',
        vertical ? 'flex-col' : 'flex-row',
        className,
      )}
      aria-label={ariaLabel}
      aria-live={ariaLive}
      role={ariaRole}
      tabIndex={0}
    >
      {Array.from({ length: repeat }, (_, i) => (
        <div
          key={i}
          className={cx(
            'flex shrink-0 justify-around [gap:var(--gap)]',
            vertical
              ? 'animate-marquee-vertical flex-col'
              : 'animate-marquee flex-row',
            pauseOnHover && 'group-hover:[animation-play-state:paused]',
            reverse && '[animation-direction:reverse]',
          )}
        >
          {children}
        </div>
      ))}
    </div>
  );
}
